module.exports = __webpack_public_path__ + "media/images/pic/family-1-dcb73c6806853410a64aac91a6f16fb8.jpeg";